import React from 'react';

const ImageJs = (props) => (
    <svg {...props} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.49992 20.1673H13.4999M4.29513 11.8721L2.73257 13.4347C2.15674 14.0105 1.83325 14.7915 1.83325 15.6058V15.6058C1.83325 16.2841 2.38313 16.834 3.06143 16.834H18.9384C19.6167 16.834 20.1666 16.2841 20.1666 15.6058V15.6058C20.1666 14.7915 19.8431 14.0105 19.2673 13.4347L17.7047 11.8721C17.1467 11.3141 16.8333 10.5573 16.8333 9.76822V7.66732C16.8333 4.44566 14.2216 1.83398 10.9999 1.83398V1.83398C7.77826 1.83398 5.16658 4.44565 5.16658 7.66731V9.76822C5.16658 10.5573 4.85311 11.3141 4.29513 11.8721Z"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ImageJs;
